export const ENERGY_REDIRECT_ROUTE_PATH = '/energygo'
export const ENERGY_REDIRECT_URI_PARAM = 'redirect_uri'
